import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigureServiceLdapComponent } from './configure-service-ldap.component';
import { CoreModule } from '@dm/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CaUploadModule } from 'app/feature/settings/ca-upload/ca-upload.module';

@NgModule({
    declarations: [ConfigureServiceLdapComponent],
    exports: [ConfigureServiceLdapComponent],
    imports: [
        CommonModule,
        CoreModule,
        ReactiveFormsModule,
        CaUploadModule,
        FormsModule,
    ],
})
export class ConfigureServiceLdapModule { }
